<template>
  <div ref="XterminateInstructions" class="transparent xterminate-instructions">
    <p
      v-for="(paragraph, i) in $t('portfolio.xterminate.instructions.paragraph')"
      v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
      :key="`portfolioXterminateInstructionsParagraph-${i}`"
    />

    <h2>{{ $t("portfolio.xterminate.instructions.howToPlay.title") }}</h2>
    <hr class="secondary" />

    <img
      alt="X-Wayne"
      src="/img/3DTextures/xterminate/instructions/hero.jpg"
      class="xterminate-instructions-image hero black"
    />
    <p
      v-for="(paragraph, i) in $t('portfolio.xterminate.instructions.howToPlay.paragraph')"
      v-html="replaceTextClass(paragraph, '{purple}', 'text-white-purple')"
      :key="`portfolioXterminateInstructionsHowToPlayParagraph-${i}`"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.stamina.title") }}</h3>
    <p>{{ $t("portfolio.xterminate.instructions.howToPlay.stamina.paragraph") }}</p>
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.stamina.altLabel')"
      src="/img/3DTextures/xterminate/instructions/energy.jpg"
      class="xterminate-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.enemies.title") }}</h3>
    <p
      v-html="
        $t('portfolio.xterminate.instructions.howToPlay.enemies.paragraph', {
          purple: 'text-white-purple'
        })
      "
    />
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.enemies.altLabel')"
      src="/img/3DTextures/xterminate/instructions/villain.jpg"
      class="xterminate-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.halo.title") }}</h3>
    <p
      v-html="
        $t('portfolio.xterminate.instructions.howToPlay.halo.paragraph', {
          purple: 'text-white-purple'
        })
      "
    />
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.halo.altLabel')"
      src="/img/3DTextures/xterminate/instructions/halo.jpg"
      class="xterminate-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.weapons.title") }}</h3>
    <p
      v-html="
        $t('portfolio.xterminate.instructions.howToPlay.weapons.paragraph', {
          purple: 'text-white-purple'
        })
      "
    />
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.weapons.altLabel')"
      src="/img/3DTextures/xterminate/instructions/weapon.jpg"
      class="xterminate-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.data.title") }}</h3>
    <p
      v-html="
        $t('portfolio.xterminate.instructions.howToPlay.data.paragraph', {
          purple: 'text-white-purple'
        })
      "
    />
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.data.altLabel')"
      src="/img/3DTextures/xterminate/instructions/armed.jpg"
      class="xterminate-instructions-image scenario black"
    />

    <h3>{{ $t("portfolio.xterminate.instructions.howToPlay.movement.title") }}</h3>
    <p>{{ $t("portfolio.xterminate.instructions.howToPlay.movement.paragraph") }}</p>
    <img
      :alt="$t('portfolio.xterminate.instructions.howToPlay.movement.altLabel')"
      src="/img/3DTextures/xterminate/instructions/keyboard-arrows.jpg"
      class="xterminate-instructions-image"
    />
  </div>
</template>

<script>
export default {
  name: "XterminateInstructions"
};
</script>

<style lang="scss" scoped>
.xterminate-instructions {
  &-image {
    @include boxShadow(0.35, true, false);
    border: 0.0625rem solid $main-blue;
    background-color: $white-raw;
    border-radius: 0.45rem;
    display: flex;
    margin: 2rem auto;
    max-width: 100%;
    max-height: 100%;

    &.black {
      border: 0.125rem solid $main-green;
      background-color: $dark-raw;
    }

    &.hero {
      @include breakpoint($xlarge) {
        height: 45vh;
        width: auto;
      }

      @include breakpoint($xxxlarge) {
        height: 40vh;
      }

      @include breakpoint($xxxxlarge) {
        height: 35vh;
      }
    }

    &.scenario {
      @include breakpoint($xlarge) {
        height: auto;
        width: 70%;
      }

      @include breakpoint($xxxlarge) {
        width: 65%;
      }

      @include breakpoint($xxxxlarge) {
        width: 50%;
      }
    }
  }
}
</style>
